import React from "react";
import "./ColorBar.css";


const ColorBar = (props) => {
  let rawData;


  if (props.data && props.data.length > 0) {
    rawData = props.data.map((elx) => {
      let x = parseFloat(elx.item) ;
      return x;
    });
    
  } else {

    return <React.Fragment> </React.Fragment>
  }

//   let rawFiltered = rawData.filter((x)=>x > 0);
//   const rawSorted = [...rawFiltered].sort((a, b) => a - b);
//   let lastValue = rawData[0];

const rawData20 = rawData.slice(0,20)

  //const colors = numberToColorGradient(rawData.slice(0,20), "#1d7529", "#ff5454") // greenish to reddish
  //const colors = numberToColorGradient(rawData20 , "#0000ff", "#ffa500"); // blue to orange
  //const colors = numberToColorGradient(rawData20 , "#0000ff", "#ff0000"); // blue to red
  const colors = numberToColorGradient(rawData20 , "#00ffff", "#222222"); // cyan to dark gray

  const divmap = colors.map((color,index)=>{
    return(
        <div
            className={"colorbar-color"}
            key = {index}
            style={{
                backgroundColor: color, // Set the background color to the hex code
            }}   
        >&nbsp;</div>
    )

  })
  


  function numberToColorGradient(numbers, startColor, endColor) {
    const min = Math.min(...numbers);
    const max = Math.max(...numbers);

    function hexToRgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
            }
        : null;
    }

    function rgbToHex(r, g, b) {
        return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
    }

    const startRgb = hexToRgb(startColor);
    const endRgb = hexToRgb(endColor);

    return numbers.map((num) => {
        const normalized = (num - min) / (max - min);
        const r = Math.round(startRgb.r + (endRgb.r - startRgb.r) * normalized);
        const g = Math.round(startRgb.g + (endRgb.g - startRgb.g) * normalized);
        const b = Math.round(startRgb.b + (endRgb.b - startRgb.b) * normalized);
        return rgbToHex(r, g, b);
    });
  }  

    return (
        <React.Fragment>
        <div className="colorbar">{divmap}</div>
        </React.Fragment>
    )
};

export default ColorBar;
